export class OtpChecker {
    constructor(authService, { otpRequest, otpResponse }) {
        this.authService = authService;
        this.otpRequest = otpRequest;
        this.otpResponse = otpResponse;
    }
    toJson() {
        return JSON.stringify({
            otpRequest: this.otpRequest,
            otpResponse: this.otpResponse,
        });
    }
    static fromJson(authService, json) {
        return new OtpChecker(authService, JSON.parse(json));
    }
    async verify(otp) {
        if (!this.otpRequest || this.otpRequest.mode === 'server') {
            return this.authService.otpVerify({
                otp: otp,
                mode: 'server',
                signature: this.otpResponse.signature,
            });
        }
        else {
            throw new Error('OTP verify failed - missing secretKey');
        }
    }
}
//# sourceMappingURL=otp-checker.js.map